import { React, useEffect, useState } from "react";
import { useForm, set } from "react-hook-form";
import { useOutletContext } from "react-router-dom";
import toastr from "../../../utils/toast";
import axios from "axios";

function PrepWithAIModal({ companyinfoId, onClose }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm();

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();
  const [loading, setLoading] = useState(false);
  const [nextMeeting, setNextMeeting] = useState(null);
  const [possibleSearches, setPossibleSearches] = useState("");

  const fetchNextMeeting = async () => {
    setGlobalLoading(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/companyinfo/meeting_data/${companyinfoId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = response.data;
      setNextMeeting(data[0]);
      console.log(data);
      setValue("possible_searches", data?.[0]?.possible_searches);
      setValue("meeting_id", data?.[0]?.meeting_id);
    } catch (error) {
      setGlobalLoading(false);
      toastr.error(error?.response?.data?.message);
    } finally {
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    fetchNextMeeting();
  }, [companyinfoId]);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const payload = { ...data, companyinfo_id: companyinfoId };
      await axios.post(
        `${API_BASE_URL}/companyinfo/createPrepAIRequest`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      onClose();
    } catch (error) {
      toastr.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div
            className="modal-content"
            style={{
              maxHeight: "80vh",
              overflowY: "auto",
            }}
          >
            <div className="modal-header">
              <h5 className="modal-title">
                <i
                  style={{ color: "#FFC107" }}
                  class="fa-solid fa-wand-sparkles me-1"
                ></i>
                AI Meeting Prep
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-12">
                  <div class="p-3 bg-info bg-opacity-10 border border-info rounded mb-2 text-muted">
                    <p className="text-muted mb-0">NEXT MEETING</p>
                    <p className="text-dark mb-0">
                      {new Date(nextMeeting?.meeting_date).toLocaleDateString(
                        "en-CA",
                      )}{" "}
                      with {nextMeeting?.candidate_name}
                    </p>
                  </div>
                  <div className="mb-2">
                    <label className="form-label">
                      Possible searches being discussed
                    </label>
                    <textarea
                      {...register("possible_searches")}
                      className="form-control"
                      rows="3"
                      placeholder="eg. CFO succession, Independent Director for audit committee, Head of Digit..."
                    ></textarea>
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Notes for the agent</label>
                    <textarea
                      {...register("additional_notes")}
                      className="form-control"
                      rows="3"
                      placeholder="Anything else to factor in - sensitivities, recent context, deal nuances..."
                    ></textarea>
                  </div>
                  <div class="p-0 mb-2 text-muted fs-10">
                    Notes are added to the company timeline:
                  </div>
                  <div className="mb-2">
                    <ul>
                      <li className="text-sm text-muted-foreground d-flex align-items-center gap-2 mb-1">
                        <i class="fa-regular fa-file-lines me-1"></i>
                        <span className="text-dark fw-medium">
                          The agent will email you:
                        </span>
                      </li>
                      <li className="text-sm text-muted-foreground d-flex align-items-center gap-2">
                        <i class="fa-solid fa-check-circle text-success me-1"></i>
                        Recap of last meeting and outstanding action items, if
                        any
                      </li>
                      <li className="text-sm text-muted-foreground d-flex align-items-center gap-2">
                        <i class="fa-solid fa-check-circle text-success me-1"></i>
                        Latest news & funding updates on{" "}
                        {nextMeeting?.company_name}
                      </li>
                      <li className="text-sm text-muted-foreground d-flex align-items-center gap-2">
                        <i class="fa-solid fa-check-circle text-success me-1"></i>
                        Background brief on your contacts - recent moves, mutual
                        connections
                      </li>
                      <li className="text-sm text-muted-foreground d-flex align-items-center gap-2">
                        <i class="fa-solid fa-check-circle text-success me-1"></i>
                        Suggested talking points tied to possible searches
                      </li>
                      <li className="text-sm text-muted-foreground d-flex align-items-center gap-2">
                        <i class="fa-solid fa-check-circle text-success me-1"></i>
                        Tailored deck draft + one-pager attached
                      </li>
                    </ul>
                  </div>
                  <div className="mb-2">
                    <div className="text-sm text-muted-foreground d-flex align-items-center gap-2 mb-1">
                      <i class="fa-regular fa-clock me-1"></i>
                      <span className="text-dark fw-medium">
                        When should we deliver this?
                      </span>
                    </div>
                    <div className="d-flex flex-column">
                      <div class="p-2 bg-default bg-opacity-10 border border-default rounded mb-2 text-muted d-flex form-check form-check-md align-items-center">
                        <input
                          type="radio"
                          {...register("delivery_type")}
                          value="now"
                          className="form-check-input ms-sm-0"
                          id="now"
                          defaultChecked
                        />
                        <label
                          style={{ cursor: "pointer", width: "100%" }}
                          for="now"
                          className="ms-2"
                        >
                          <p className="text-dark fw-medium mb-0">Send Today</p>
                          <p className="text-muted fw-normal mb-0 fs-10">
                            Generate now and email within the next hour.
                          </p>
                        </label>
                      </div>
                      <div class="p-2 bg-default bg-opacity-10 border border-default rounded mb-2 text-muted d-flex form-check form-check-md align-items-center">
                        <input
                          type="radio"
                          {...register("delivery_type")}
                          value="24h_before"
                          className="form-check-input ms-sm-0"
                          id="before"
                        />
                        <label
                          style={{ cursor: "pointer", width: "100%" }}
                          for="before"
                          className="ms-2"
                        >
                          <p className="text-dark fw-medium mb-0">
                            24 hours before the meeting
                          </p>
                          <p className="text-muted mb-0 fw-normal fs-10">
                            Freshest news & update, timed to land just before.
                          </p>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="submit"
                className="btn btn-secondary me-2"
                disabled={loading}
                onClick={handleSubmit(onSubmit)}
              >
                {loading ? (
                  "Please wait..."
                ) : (
                  <>
                    <i class="fa-regular fa-envelope me-1"></i> Send Prep to My
                    Inbox
                  </>
                )}
              </button>
              <button type="button" className="btn btn-light" onClick={onClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrepWithAIModal;
